export const RUBY_IMPORT_YAML = `project:
  name: recipe-ruby
  tags:
    - zerops-recipe

services:
  - hostname: app
    type: ruby@3.4
    buildFromGit: https://github.com/zeropsio/recipe-ruby
    enableSubdomainAccess: true

  - hostname: db
    type: postgresql@16
    mode: NON_HA`;
